<template>
  <div class="entrant-wrapper-block">
    <p id="credits-warning-message" class="red" v-if="entrant_credits_missing">Your submission must include one writer, one producer and one director.</p>
    <div class="row width-100 no-gutters">

      <div class="left entrant-left entrant-listing col-12 col-md-4" :class="entrant_credits_missing ? 'required' : ''">
        <ul v-if="role=='guest'"  class="drag-episode-titles">
          <li class="entrant-item" :class="leftSidebarClass(index, entrant)" v-for="(entrant, index) in entrants" @click="entrantActive(index)">
            <div class="action-icons pull-right hide-me">
              <div class="d-inline-block align-middle move pl-3 pr-2"><span class="actions">Reorder<br/>Entrants</span><i class="fa fa-arrows-v"></i></div>
              <div class="d-inline-block align-middle" v-if="entrants.length > 1 && update_allowed" @click.prevent="activateDeleteEntrantPopup(entrant, index)"><trash class=" delete-entrant svg-18"></trash></div>
            </div>
            <div v-if="entrant.first_name">{{index+1}} - {{entrant.first_name}} {{ entrant.last_name }}
              <span class="f-12 greyed-light" v-if="entrant.is_writer == 1 || entrant.is_producer == 1 || entrant.is_director == 1">{{ '(' + entrantCredits(entrant) + ')' }}</span>
            </div>
            <div v-else>{{index+1}} - </div>
          </li>
        </ul>
        <ul v-else>
          <draggable class="drag-episode-titles" v-model="entrants" @start="drag=true" @end="drag=false, updateWeights()">

            <li class="entrant-item" :class="leftSidebarClass(index, entrant)" v-for="(entrant, index) in entrants" @click="entrantActive(index)">
              <div class="action-icons pull-right hide-me">
                <div class="d-inline-block align-middle move pl-3 pr-2"><span class="actions">Reorder<br/>Entrants</span><i class="fa fa-arrows-v"></i></div>
                <div class="d-inline-block align-middle" v-if="entrants.length > 1 && update_allowed" @click.prevent="activateDeleteEntrantPopup(entrant, index)"><trash class=" delete-entrant svg-18"></trash></div>
              </div>
              <div v-if="entrant.first_name">{{index+1}} - {{entrant.first_name}} {{ entrant.last_name }}
                <span class="f-12 greyed-light" v-if="entrant.is_writer == 1 || entrant.is_producer == 1 || entrant.is_director == 1">{{ '(' + entrantCredits(entrant) + ')' }}</span>
              </div>
              <div v-else>{{index+1}} - </div>
            </li>
          </draggable>
        </ul>
        <a href="#" @click.prevent="addNewEntrant()" id="createNewEntrantFromLeft" class="mt-2 btn btn-create w-100" tabindex="-1" v-if="update_allowed">
          <plus_circle class="svg-24 svg-black"></plus_circle>
          <span>Add another entrant</span>
        </a>
      </div>

      <div class="right omega entrant-right entrant-entry-right-form col-12 col-md-8 pl-3">
        <div v-for="(entrant, index) in entrants">
          <div class="vid-wrapper" v-if="index === activeEntrantIndex">
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.first_name == null || entrant.first_name == '')) ? 'required' : ''">
              <label :for="'first_name' + index" class="col-6 pl-2">First Name: <em class="yellow no-style">*</em></label>
              <input @blur="saveEntrant('first_name', index, entrant, true)" type="text" v-model="entrant.first_name" required :name="'first_name' + index" :id="'first_name' + index"  class="first_name form-control col-6" maxlength="255" :disabled="!update_allowed">
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.last_name == null || entrant.last_name == '')) ? 'required' : ''">
              <label :for="'last_name' + index" class="col-6 pl-2">Last Name: <em class="yellow no-style">*</em></label>
              <input @blur="saveEntrant('last_name', index, entrant, true)" type="text" v-model="entrant.last_name" required :name="'last_name' + index" :id="'last_name' + index"  class="last_name form-control col-6" maxlength="255" :disabled="!update_allowed">
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.email == null || entrant.email == '' || entrant.email_invalid)) ? 'required' : ''">
              <label :for="'email' + index" class="col-6 pl-2">Email: <em class="yellow no-style">*</em></label>
              <input @blur="saveEntrant('email', index, entrant, true)" type="email" v-model="entrant.email" :id="'email' + index" required :name="'email' + index"  class="email form-control col-6" maxlength="255" :disabled="!update_allowed">
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.phone == null || entrant.phone == '')) ? 'required' : ''">
              <label :for="'phone' + index" class="col-6 pl-2">Phone Number: <em class="yellow no-style">*</em></label>
              <input @blur="saveEntrant('phone', index, entrant, true)" type="text" v-model="entrant.phone" :id="'phone' + index" required :name="'phone' + index"  class="last_name form-control col-6" maxlength="255" :disabled="!update_allowed">
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.address_1 == null || entrant.address_1 == '')) ? 'required' : ''">
              <label :for="'address_1' + index" class="col-6 pl-2">Street Address: <em class="yellow no-style">*</em></label>
              <input @blur="saveEntrant('address_1', index, entrant, true)" type="text" v-model="entrant.address_1" :id="'address_1' + index" required :name="'address_1' + index" class="last_name form-control col-6" maxlength="255" :disabled="!update_allowed">
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.city == null || entrant.city == '')) ? 'required' : ''">
              <label :for="'city' + index" class="col-6 pl-2">City: <em class="yellow no-style">*</em></label>
              <input @blur="saveEntrant('city', index, entrant, true)" type="text" v-model="entrant.city" :id="'city' + index" :name="'city' + index" required class="last_name form-control col-6" maxlength="255" :disabled="!update_allowed">
            </div>
            <div class="form-group-beside individual-field-value row no-gutters state-group" :class="(entrant.required && (entrant.state == null || entrant.state == '')) ? 'required' : ''">
              <label :for="'state' + index" class="col-6 pl-2">State: <em class="yellow no-style">*</em></label>
              <Select2 :id="'state' + index" class="col-6 d-block video-status-dropdown-select" required :name="'state' + index" v-model="entrant.state" :options="stateList" :settings="{placeholder: 'Select state', disabled: update_allowed ? '' : 'readonly'}" @change="saveEntrant('state', index, entrant, true)" >
              </Select2>
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.zip == null || entrant.zip == '')) ? 'required' : ''">
              <label :for="'zip' + index" class="col-6 pl-2">Zip Code: <em class="yellow no-style">*</em></label>
              <input @blur="saveEntrant('zip', index, entrant, true)" type="text" v-model="entrant.zip" :id="'zip' + index" required :name="'zip' + index" class="last_name form-control col-6" maxlength="255" :disabled="!update_allowed">
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.college == null || entrant.college == '')) ? 'required' : ''">
              <label :for="'college' + index" class="col-6 pl-2">College: <em class="yellow no-style">*</em></label>
              <Select2 :id="'college' + index" required :name="'college' + index" class="col-6 d-block video-status-dropdown-select" v-model="entrant.college" :options="universities" :settings="{placeholder: 'Select College', disabled: update_allowed ? '' : 'readonly'}" @select="preSaveEntrantCollege($event, 'college', index, entrant, true)">
              </Select2>
              <input type="hidden" v-model="entrant.college_value">
            </div>
<!--            <div class="form-group-beside individual-field-value row no-gutters" v-if="entrant.college === 'Other'">-->
<!--              <label :for="'college_other' + index" class="col-6 pl-2">College Other: <em class="yellow no-style">*</em></label>-->
<!--              <input @blur="saveEntrant('college_other', index, entrant, false)" type="text" v-model="entrant.college_other" :id="'college_other' + index"  class="last_name form-control col-6" maxlength="255" :disabled="!update_allowed">-->
<!--            </div>-->
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.degree == null || entrant.degree == '')) ? 'required' : ''">
              <label :for="'degree' + index" class="col-6 pl-2">Degree: <em class="yellow no-style">*</em></label>
              <Select2 :id="'degree' + index" required :name="'degree' + index" class="col-6 d-block video-status-dropdown-select" v-model="entrant.degree" :options="degree_list" :settings="{placeholder: 'Degree', disabled: update_allowed ? '' : 'readonly'}" @change="saveEntrant('degree', index, entrant, true)" >
              </Select2>
            </div>
<!--            <div class="form-group-beside individual-field-value row no-gutters" v-if="entrant.degree === 'Other'">-->
<!--              <label :for="'degree_other' + index" class="col-6 pl-2">Degree Other: <em class="yellow no-style">*</em></label>-->
<!--              <input @blur="saveEntrant('degree_other', index, entrant, false)" type="text" v-model="entrant.degree_other" :id="'degree_other' + index"  class="last_name form-control col-6" maxlength="255" :disabled="!update_allowed">-->
<!--            </div>-->
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.graduation_year == null || entrant.graduation_year == '')) ? 'required' : ''">
              <label :for="'graduation_year' + index" class="col-6 pl-2">Graduation Year: <em class="yellow no-style">*</em></label>
              <Select2 :id="'graduation_year' + index" required :name="'graduation_year' + index" class="col-6 d-block video-status-dropdown-select" v-model="entrant.graduation_year" :options="graduation_year_list" :settings="{placeholder: 'Graduation Year', disabled: update_allowed ? '' : 'readonly'}" @change="saveEntrant('graduation_year', index, entrant, true)" >
              </Select2>
            </div>
            <div class="form-group-beside row no-gutters no-border" :class="(entrant.required && (entrant.is_director == 0 && entrant.is_writer == 0 && entrant.is_producer == 0)) ? 'required' : ''">
                <div class="checkbox-group-beside d-inline-flex col-4 mb-4 pb-1 form-field-wrapper">
                  <input v-if="update_allowed" @change="saveEntrant('producer', index, entrant, false)" type="checkbox" :id="'producer' + index" v-model="entrant.is_producer" class="checkbox form-control">
                  <label :for="'producer' + index" class="box-checking w-100 pl-5" :class="(!update_allowed && entrant.is_producer == 1) ? 'checked' : ''" >Producer</label>
                </div>
                <div class="checkbox-group-beside d-inline-flex col-4 mb-4 pb-1 form-field-wrapper">
                  <input v-if="update_allowed" @change="saveEntrant('writer', index, entrant, false)" type="checkbox" :id="'writer' + index" v-model="entrant.is_writer" class="checkbox form-control">
                  <label :for="'writer' + index" class="box-checking w-100 pl-5" :class="(!update_allowed && entrant.is_writer == 1) ? 'checked' : ''" >Writer</label>
                </div>
                <div class="checkbox-group-beside d-inline-flex col-4 mb-4 pb-1 form-field-wrapper">
                  <input v-if="update_allowed" @change="saveEntrant('director', index, entrant, false)" type="checkbox" :id="'director' + index" v-model="entrant.is_director" class="checkbox form-control">
                  <label :for="'director' + index" class="box-checking w-100 pl-5" :class="(!update_allowed && entrant.is_director == 1) ? 'checked' : ''" >Director</label>
                </div>
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.bio == null || entrant.bio == '') || entrant.number_over > 0) ? 'required' : ''">
              <label :for="'bio' + index" class="col-6 pl-2">Bio: <em class="yellow no-style">*</em></label>
              <div class="col-12 col-md-6">
                <textarea @keyup="wordCountFixer($event.target.value, index)" @blur="saveEntrant('bio', index, entrant, false)" type="text" v-model="entrant.bio" :id="'bio' + index"  class="form-control-textarea-entrant has_word_count_max" rows="5" :disabled="!update_allowed"></textarea>
                <div class="xsmall placeholder-text">Limited to <span class="max_words">{{ maxWords }}</span> words</div>
              </div>
              <div class="red pl-2" v-if="entrant.number_over > 0">You are <span v-text="entrant.number_over"></span> words over the limit.</div>
            </div>
            <div class="image-upload-field" :class="(entrant.required && (entrant.headshot_preview == null || entrant.headshot_preview == '')) ? 'required' : ''">
              <image-upload-component-entrant-block :entry="entrant" machine_name="headshot_preview" description="" display_name="Headshot" :required="true" imagename="" viewurl="entrant.headshot_preview" :update_allowed="update_allowed" :entrantImage="true" minimum_width="-100" minimum_height="-100" :role="role"></image-upload-component-entrant-block>
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.hometown == null || entrant.hometown == '')) ? 'required' : ''">
              <label :for="'hometown' + index" class="col-6 pl-2">Hometown: <em class="yellow no-style">*</em></label>
              <input @blur="saveEntrant('hometown', index, entrant, true)" type="text" v-model="entrant.hometown" :id="'hometown' + index" :name="'hometown' + index" required class="city form-control col-6" maxlength="255" :disabled="!update_allowed">
              <div class="description">City, State
              </div>
            </div>
            <div class="form-group-beside individual-field-value row no-gutters" :class="(entrant.required && (entrant.highschool == null || entrant.highschool == '')) ? 'required' : ''">
              <label :for="'highschool' + index" class="col-6 pl-2">High School: <em class="yellow no-style">*</em></label>
              <input @blur="saveEntrant('highschool', index, entrant, true)" type="text" v-model="entrant.highschool" :id="'highschool' + index" :name="'highschool' + index" required class="highschool form-control col-6" maxlength="255" :disabled="!update_allowed">
            </div>
            <div class="form-group-beside individual-field-value row no-gutters">
              <label :for="'bio' + index" class="col-6 pl-2">Social Media Handles: </label>
              <textarea @blur="saveEntrant('social_handles', index, entrant, false)" type="text" v-model="entrant.social_handles" :id="'social_handles' + index"  class="social_handles form-control-textarea-entrant col-6" :disabled="!update_allowed"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="modalTriggerConfirmDelete" @close="modalTriggerConfirmDelete = false">
      <h3 slot="header">Removing Entrant File</h3>
      <div class="content" slot="body">
        <div v-if="entrantModalDelete.first_name">Are you sure you want to remove {{entrantModalDelete.first_name}} {{entrantModalDelete.last_name}} from this entry? </div>
        <div v-else>Are you sure you want to remove this entrant?</div>
      </div>
      <div class="form-group-submit clearfix" slot="footer">
        <button class="btn btn-cancel btn-transparent pull-left" @click.prevent="modalTriggerConfirmDelete = false">Cancel</button>
        <button class="pull-right" @click.prevent="deleteEntrant(entrantModalDelete.id)">Yes, Remove</button>
      </div>
    </modal>

  </div>

</template>

<script>
import Checkmark from "./icons/checkmark";
import modal from "./Modal";
import upload from './icons/upload.vue';
import play from './icons/play.vue';
import calendar from './icons/calendar.vue';
import plus_circle from "./icons/plus_circle.vue";
import save from "./icons/save.vue";
import trash from "./icons/trash.vue";
import download from "./icons/download.vue";
import close from "./icons/close.vue";
import Select2 from 'v-select2-component';

export default {
  name: "EntrantBlock",
  components: {
    Checkmark,
    modal, Select2, upload, play, calendar, save, plus_circle, trash, download, close
  },
  props: ['entryid', 'entry_entrants', 'update_allowed', 'universities', 'states', 'degree_list', 'graduation_year_list', 'role'],
  data() {
    return {
      entrants: this.entry_entrants,
      activeEntrantIndex: 0,
      entrantModalDelete: '',
      modalTriggerConfirmDelete: false,
      stateList: this.createStateOptions(),
      maxWords: 125,
      is_saving: false,
      entrant_credits_missing: false,
      is_director_checked: false,
      is_writer_checked: false,
      is_producer_checked: false,
    }
  },
  methods: {
    createStateOptions: function() {
      let app = this;
      let stateArray = [];
      $.each(app.states, function(i,v) {
        stateArray.push(v);
      })
      return stateArray;
    },
    underlineFields: function() {
      let app = this;
      const notRequiredFields = ["address_2", 'country', 'middle_name', 'degree_other', 'college_other', 'weight', 'image_upload_headshot', 'social_handles'];
      let submitFormBlock = true;
      // Loop through entrants
      app.entrants.forEach(function (entrant, index) {
        // loop through fields and make sure they aren't null
        app.entrants[index].email_invalid = false;
        for (const field in entrant) {
          // Check that the field is actually a required field and it's not NULL
          if((!notRequiredFields.includes(field)) && (entrant[field] == null)) {
            submitFormBlock = false;
            app.entrants[index].required = true;
          } else if((field == 'email') && (!app.validateEmail($.trim(entrant[field])))) {
            submitFormBlock = false;
            app.entrants[index].required = true;
            app.entrants[index].email_invalid = true;
          }
        }
        if((entrant.is_director == 0) && (entrant.is_writer == 0) && (entrant.is_producer == 0)) {
          submitFormBlock = false;
          app.entrants[index].required = true;
        }

        if(entrant.is_director == 1) {
          app.is_director_checked = true;
        }
        if(entrant.is_writer == 1) {
          app.is_writer_checked = true;
        }
        if(entrant.is_producer == 1) {
          app.is_producer_checked = true;
        }

        app.wordCountFixer(entrant.bio, index);
        if(entrant.number_over > 0) {
          submitFormBlock = false;
          app.entrants[index].required = true;
        }

      });

        if(!(app.is_director_checked && app.is_writer_checked && app.is_producer_checked)) {
            app.entrant_credits_missing = true;
            submitFormBlock = false;
        } else {
          app.entrant_credits_missing = false;
        }

      return submitFormBlock;
    },
    leftSidebarClass: function(index, entrant) {
      let app = this;
      let sidebarClass = '';
      if(index == app.activeEntrantIndex) {
        sidebarClass = 'active';
      }

      if(entrant.required) {
        sidebarClass += ' required';
      }

      return sidebarClass;
    },
    entrantActive: function(index) {
      let app = this;
      app.activeEntrantIndex = index;
    },
    preSaveEntrantCollege({id, text}, value, index, entrant, requiredValue) {
      this.entrants[index]['college_value'] = {id, text}.text;
      this.saveEntrant(value, index, entrant, requiredValue)
    },
    saveEntrant: function(value, index, entrant, requiredValue) {
      let app = this;
      if(app.is_saving || app.role == 'admin') {
        return false;
      }
      app.is_saving = true;

      if($('#select2-state'+index+'-container').text() != 'Select state' && $('#select2-state'+index+'-container').text() != entrant.state) {
        entrant.state = $('#select2-state'+index+'-container').text();
      }

      // Check to make sure value isn't empty or empty with spaces
      if(requiredValue && _.trim(entrant[value]) == '') {
        app.entrants[index][value] = '';
      }

      let actionUrl = `/entrant/update`;
      window.axios(
          {
            method: 'POST',
            url: actionUrl,
            data: {
              entry_id: app.entryid,
              entrant: entrant
            }
          }).then(function(response) {
            if(entrant.id == null) {
              entrant.id = response.data.entrant_id;
            }
          app.is_saving = false;
      }).catch(function (err) {
        let errorMessage = err.response.status + ' status error';
        app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    },
    saveAllEntrants: function(entrant) {
      let app = this;

      app.entrants.forEach(function (entrantVal, index) {
        let actionUrl = `/entrant/update`;
        window.axios(
            {
              method: 'POST',
              url: actionUrl,
              data: {
                entry_id: app.entryid,
                entrant: entrantVal
              }
            }).then(function(response) {
              location.reload();
        }).catch(function (err) {
          let errorMessage = err.response.status + ' status error';
          app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
        });
      });
    },
    addNewEntrant: function() {
      let app = this;
      app.activeEntrantIndex = app.entrants.length;
      app.entrants.push({
        'id': null,
        'weight': app.entrants.length,
        'first_name': null,
        'last_name': null,
        'email': null,
        'phone': null,
        'address_1': null,
        'state': '',
        'city': null,
        'zip': null,
        'college': null,
        'college_value': null,
        'college_other': null,
        'degree': null,
        'degree_other': null,
        'graduation_year': null,
        'is_producer': false,
        'is_writer': false,
        'is_director': false,
        'bio': null,
        'hometown': null,
        'highschool': null,
        'required': false,
      })
    },
    updateWeights: function() {
      let app = this;
      var weightIdValues = app.entrants.map(function(x, index){
        var weightIdObject = {
          'id': x.id,
          'weight': index
        };
        return(weightIdObject)
      });

      let actionUrl = `/entrant/updateWeights`;
      window.axios(
          {
            method: 'POST',
            url: actionUrl,
            data: {
              entry_id: app.entryid,
              weights: weightIdValues
            }
          }).then(function(response) {
        // console.log('response');
      }).catch(function (err) {
        let errorMessage = err.response.status + ' status error';
        app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    },
    activateDeleteEntrantPopup(entrant, index) {
      let app = this;
      app.modalTriggerConfirmDelete = true;
      app.entrantModalDelete = entrant;
      app.activeEntrantIndex = index;
    },
    deleteEntrant: function(entrantId) {
      let app = this;
      if(!entrantId) {
        app.entrants.splice(app.activeEntrantIndex, 1);
        app.modalTriggerConfirmDelete = false;
        if(app.activeEntrantIndex != 0) {
          app.activeEntrantIndex = app.activeEntrantIndex-1;
        } else {
          app.activeEntrantIndex = 0;
        }
        return;
      }

      let indexlist= [];
      app.entrants.splice(app.activeEntrantIndex, 1);
      app.entrants.forEach(function(entrant, index){
        indexlist[index] = entrant.id;
      });
      let actionUrl = `/entrant/detach`;
      window.axios(
          {
            method: 'DELETE',
            data: {
              'entrant_id':entrantId,
              'indexlist' : indexlist,
            },
            url: actionUrl,
          }).then(function(response) {
        app.modalTriggerConfirmDelete = false;
        app.activeEntrantIndex = 0;
        window.location.reload();
      }).catch(function (err) {
        let errorMessage = err.response.status + ' status error.';
        app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    },
    entrantCredits(entrantVal) {
      let entrantArray = [];
      if(entrantVal.is_director == 1) { entrantArray.push('Director') }
      if(entrantVal.is_producer == 1) { entrantArray.push('Producer') }
      if(entrantVal.is_writer == 1) { entrantArray.push('Writer') }
      let output = '';
      entrantArray.forEach(function(value, index) {
        output += value;
        if(index < entrantArray.length-1) {
          output += ', ';
        }
      })
      return output;
    },
    validateEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    wordCountFixer: function(value, index) {
      let text = value;
      let app = this;
      if(text != null) {
        let numberWords = app.wordCounter(text);
        if (numberWords > app.maxWords) {
          app.entrants[index].number_over = numberWords - app.maxWords;
        } else {
          app.entrants[index].number_over = 0;
        }
      }
    },
    wordCounter: function(s){
      s = s.replace(/(^\s*)|(\s*$)/gi,"");//exclude  start and end white-space
      s = s.replace(/[ ]{2,}/gi," ");//2 or more space to 1
      s = s.replace(/\n /,"\n"); // exclude newline with a start spacing
      return s.split(' ').length;
    },
  }
}
</script>